import { inject, bindable, customElement } from 'aurelia';

@customElement({ name: 'fa-svg', template: '<template></template>' })
@inject(Element)
export class FaSvg {
    @bindable public icon: string;

    private _element: HTMLElement;
    private _attached = false;

    constructor(element: HTMLElement) {
        this._element = element;
    }

    public iconChanged(newIcon: string): void {
        if (!this._attached) { return; }
        this._rebuild(newIcon);
    }

    public attached(): void {
        this._attached = true;
        this._rebuild(this.icon);
    }

    public detaching(): void {
        this._attached = false;
    }

    private _rebuild(iconClass: string): void {
        this._element.innerHTML = iconClass ? `<i class="${iconClass}"></i>` : '';
    }
}
